import { Chart, DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutBrokeragePlanningPerformanceRevenue extends Layout {
    chartRevenue: Chart;
    sourceBPPerfRevenue: DataSource;
    tableBPPerfRevenue: Table;
}
